import { useCallback } from 'react';

import { useCurrentUser } from 'hooks/api/use-current-user';
import { useSelectedClient } from 'hooks/use-selected-client';
import { useImpersonation } from 'hooks/use-impersonation';

export interface UseWorkspaceRouteResult {
  isAdminWorkspace: boolean;
  selectedClientId: string | number | undefined;
  resolveRoute: (adminPath: string, portalPath: string) => string;
}

export const useWorkspaceRoute = (): UseWorkspaceRouteResult => {
  const { data: currentUser } = useCurrentUser();
  const { selectedClient } = useSelectedClient();
  const { impersonatingUser, isImpersonating } = useImpersonation();

  const isAdmin = !!(currentUser?.fdUser || currentUser?.clientAdmin);
  const isUserView = !!(impersonatingUser || isImpersonating());
  const isAdminWorkspace = isAdmin && !isUserView && !!selectedClient;

  const resolveRoute = useCallback(
    (adminPath: string, portalPath: string): string =>
      isAdminWorkspace ? adminPath : portalPath,
    [isAdminWorkspace]
  );

  return {
    isAdminWorkspace,
    selectedClientId: selectedClient?.id,
    resolveRoute,
  };
};
